<ion-text>
  <h1>{{text}}</h1>
</ion-text>
